/** Each provider's name for the screen, and which ones connect from here. */

export const PROVIDER_NAMES: Record<string, string> = {
  google: "Google",
  fitbit: "Fitbit",
  withings: "Withings",
  garmin: "Garmin",
  strava: "Strava",
  claude: "Claude",
  remarkable: "reMarkable",
  audiobookshelf: "Audiobookshelf",
  eufy: "Eufy",
};

/** The providers whose consent flow runs in the browser (`connections/domain.py`, `FLOWS`). */
export const FLOWS = new Set(["google", "fitbit", "withings"]);

export const providerName = (provider: string) => PROVIDER_NAMES[provider] ?? provider;
